export enum PatientsTagsEnum {
  RETINOPATHIE_DIABETIQUE = 'Rétinopathie diabétique',
  MACULOPATHIE_DIABETIQUE = 'Maculopathie diabétique',
  COMPLICATIONS_VISUELLES = 'Complications visuelles',
}

export const allPatientsTagsEnum = [PatientsTagsEnum.RETINOPATHIE_DIABETIQUE, PatientsTagsEnum.MACULOPATHIE_DIABETIQUE, PatientsTagsEnum.COMPLICATIONS_VISUELLES]

// Map enum value -> enum key name so UI code can derive a stable key to lookup translations.
export const PatientsTagsKeyByValue: Record<string, keyof typeof PatientsTagsEnum> = {
  [PatientsTagsEnum.RETINOPATHIE_DIABETIQUE]: 'RETINOPATHIE_DIABETIQUE',
  [PatientsTagsEnum.MACULOPATHIE_DIABETIQUE]: 'MACULOPATHIE_DIABETIQUE',
  [PatientsTagsEnum.COMPLICATIONS_VISUELLES]: 'COMPLICATIONS_VISUELLES',
}

export const enum PatientsLanguagesEnum {
  NL = 'Nederlands',
  FR = 'Français',
  EN = 'English',
}
